export const MODE_EXTERNAL_REFERENCE = 'external_reference'
export const MODE_REPLENISHMENT_ID = 'replenishment_id'

export const DELIVERY_DELIVERED = 'delivered'
export const DELIVERY_NOT_DELIVERED = 'not_delivered'
export const DELIVERY_UNKNOWN = 'unknown'

export const ERROR_NATURA_REFUSED = 'natura_refused'
export const ERROR_NATURA_NO_RESPONSE = 'natura_no_response'
export const ERROR_NATURA_AUTH_FAILED = 'natura_auth_failed'
export const ERROR_AMBIGUOUS_EXTERNAL_REFERENCE = 'ambiguous_external_reference'
export const ERROR_RESEND_IN_PROGRESS = 'resend_in_progress'
export const ERROR_PAYLOAD_BUILD_FAILED = 'payload_build_failed'
export const ERROR_INTEGRATION_UNUSABLE = 'integration_unusable'

// These come back on a 502 carrying the full round trip, so they render as a
// result rather than as a failure — the round trip is what ops came for.
export const NATURA_OUTCOME_ERRORS = [ERROR_NATURA_REFUSED, ERROR_NATURA_NO_RESPONSE, ERROR_NATURA_AUTH_FAILED]

// The platform's own message is the diagnostic for these two, so it is shown
// verbatim under the translated headline instead of being swallowed.
export const ERRORS_WITH_RAW_DETAIL = [ERROR_PAYLOAD_BUILD_FAILED, ERROR_INTEGRATION_UNUSABLE]

// Every rejection code the platform can answer with. Anything outside this list
// falls back to the generic panel rather than rendering an untranslated string.
export const KNOWN_REJECTIONS = [
  'replenishment_not_found',
  'missing_identifier',
  'no_channel_integration',
  'qa_store_skipped',
  'not_completed',
  'return_replenishment_unsupported',
  'lock_unavailable',
  'circuit_open',
  ERROR_AMBIGUOUS_EXTERNAL_REFERENCE,
  ERROR_RESEND_IN_PROGRESS,
  ERROR_PAYLOAD_BUILD_FAILED,
  ERROR_INTEGRATION_UNUSABLE,
]
